import React from "react";

/**
 * Tech stack marquee — vrais SVG officiels via Simple Icons CDN.
 * Couleur monochrome #1A2F6E/50% sur fond clair par défaut, restoration de la couleur de marque au hover.
 * Hauteur fixée à 28px, marquee infini lent (40s), pause au hover sur le bandeau entier.
 *
 * Note CDN : https://cdn.simpleicons.org/{slug}/{hex}  (sans alpha)
 *           https://cdn.simpleicons.org/{slug}        (couleur de la marque)
 */
const LOGOS = [
    { slug: "framer", name: "Framer" },
    { slug: "webflow", name: "Webflow" },
    { slug: "figma", name: "Figma" },
    { slug: "wordpress", name: "WordPress" },
    { slug: "shopify", name: "Shopify" },
    { slug: "google", name: "Google" },
    { slug: "greensock", name: "GSAP" },
    { slug: "notion", name: "Notion" },
];

export default function TechStack() {
    const loop = [...LOGOS, ...LOGOS];
    return (
        <section
            aria-label="Notre stack technique"
            className="relative bg-[#F7F7F5] py-14 md:py-20"
            data-testid="techstack-section"
        >
            <div className="max-w-7xl mx-auto px-4 md:px-8 text-center">
                <p className="text-[11px] md:text-xs font-bold uppercase tracking-[0.28em] text-[#1A2F6E]/55">
                    Les outils qu'on maîtrise
                </p>
            </div>

            <div className="relative mt-10 md:mt-14 marquee-mask pause-on-hover">
                <div
                    className="flex items-center gap-16 md:gap-24 animate-marquee-slow whitespace-nowrap will-change-transform"
                    aria-hidden
                >
                    {loop.map((l, i) => (
                        <LogoItem key={`${l.slug}-${i}`} slug={l.slug} name={l.name} />
                    ))}
                </div>
            </div>
        </section>
    );
}

function LogoItem({ slug, name }) {
    return (
        <div
            className="group relative inline-flex items-center justify-center h-7 w-auto shrink-0"
            title={name}
            aria-label={name}
        >
            <img
                src={`https://cdn.simpleicons.org/${slug}/1A2F6E`}
                alt=""
                width="28"
                height="28"
                loading="lazy"
                className="h-7 w-auto opacity-50 group-hover:opacity-0 transition-opacity duration-300"
            />
            <img
                src={`https://cdn.simpleicons.org/${slug}`}
                alt={name}
                width="28"
                height="28"
                loading="lazy"
                className="absolute inset-0 m-auto h-7 w-auto opacity-0 group-hover:opacity-100 transition-opacity duration-300"
            />
        </div>
    );
}
